import api from '@/shared/utils/apiConfig';

export interface DentalChair {
  id: string;
  clinicId: string;
  name: string;
  code: string;
  isActive: boolean;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDentalChairPayload {
  clinicId: string;
  name: string;
  code?: string;
  sortOrder?: number;
}

export interface UpdateDentalChairPayload {
  name?: string;
  code?: string;
  isActive?: boolean;
  sortOrder?: number;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
}

export const dentalChairAPI = {
  getAll: async (
    clinicId: string,
    includeInactive = false
  ): Promise<ApiResponse<DentalChair[]>> => {
    const response = await api.get('/chairs', {
      params: {
        clinicId,
        ...(includeInactive ? { includeInactive: 'true' } : {}),
      },
    });
    return response.data;
  },

  create: async (payload: CreateDentalChairPayload): Promise<ApiResponse<DentalChair>> => {
    const response = await api.post('/chairs', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateDentalChairPayload
  ): Promise<ApiResponse<DentalChair>> => {
    const response = await api.put(`/chairs/${id}`, payload);
    return response.data;
  },

  deactivate: async (id: string): Promise<ApiResponse<DentalChair>> => {
    const response = await api.delete(`/chairs/${id}`);
    return response.data;
  },
};
